<template>
  <div class="simple-page">
    <header><button @click="back">‹</button><strong>提交结果</strong><i></i></header>
    <main>
      <div class="success-icon">✓</div>
      <h2>申请已提交</h2>
      <p>申请单号</p>
      <strong class="request-no">{{ requestNo }}</strong>
      <p>可在开票记录中查看最新处理进度，发票开具后将发送至收票邮箱。</p>
      <button class="primary" @click="$router.replace('/gameJump/invoiceCenter/records')">查看开票记录</button>
      <button class="plain" @click="closePage">返回游戏</button>
    </main>
  </div>
</template>
<script>
import { callHideToolbar, phoneBackButtonListener } from "@/bridge/AppJsBridge";
import { trackInvoiceEvent } from "./tracking";
import { closeInvoiceCenter } from "./common";
export default {
  computed: { requestNo() { return this.$route.params.requestNo; } },
  created() { callHideToolbar(true); phoneBackButtonListener(() => this.back()); },
  beforeDestroy() { callHideToolbar(false); },
  methods: {
    back() { this.$router.replace('/gameJump/invoiceCenter'); },
    closePage() {
      trackInvoiceEvent("INVOICE_CENTER_CLOSE_CLICK", { from_page: "invoice_result", request_no: this.requestNo });
      closeInvoiceCenter();
    },
  },
};
</script>
<style lang="scss" scoped>
.simple-page { min-height: 100%; background: #f5f6f8; color: #222; }
header { height: 48px; display: flex; align-items: center; justify-content: space-between; padding: 0 14px; background: #fff; }
header button { border: 0; background: transparent; font-size: 28px; } header i { width: 24px; }
main { margin: 12px; padding: 42px 20px; text-align: center; background: #fff; border-radius: 10px; }
.success-icon { width: 66px; height: 66px; margin: auto; border-radius: 50%; color: #fff; background: #41b883; font-size: 44px; line-height: 66px; }
p { color: #888; line-height: 1.6; }.request-no { display: block; margin: 8px 0 22px; font-size: 17px; }
button.primary, button.plain { width: 100%; height: 44px; margin-top: 14px; border-radius: 22px; }
button.primary { border: 0; color: #fff; background: #3978f6; } button.plain { border: 1px solid #3978f6; color: #3978f6; background: #fff; }
</style>
